import { OPTIONS_UPDATE_EVENT } from "../../lib/constants.js";
import _sfc_main$1 from "../code_editor/code_editor.vue.js";
import overlay_default from "../tools/overlay.vue.js";
/* empty css                                                */
import { createBlock, createElementBlock, createElementVNode, createVNode, normalizeClass, openBlock, renderSlot, resolveComponent, resolveDirective, unref, withCtx, withDirectives } from "vue";
//#region src/components/code_panel/code_panel.vue
var _hoisted_1 = { class: "d-pie-400 d-pbe-200 d-pe-auto" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodePanel" }, {
	props: {
		options: {
			type: Object,
			required: true
		},
		info: {
			type: Object,
			required: true
		},
		settings: {
			type: Object,
			required: true
		},
		disabledMembers: {
			type: Set,
			default: () => /* @__PURE__ */ new Set()
		},
		devMode: {
			type: Boolean,
			default: false
		},
		hasChanges: {
			type: Boolean,
			default: false
		},
		fullScreen: {
			type: Boolean,
			default: false
		}
	},
	emits: [OPTIONS_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		return (_ctx, _cache) => {
			const _component_dt_stack = resolveComponent("dt-stack");
			const _directive_dt_scrollbar = resolveDirective("dt-scrollbar");
			return openBlock(), createBlock(overlay_default, { class: normalizeClass(["dtc-code-panel", [`dtc-code-panel-scheme--${__props.settings.code.scheme}`, `dtc-code-panel-scheme--${__props.settings.code.scheme}--${__props.settings.root.theme}`]]) }, {
				content: withCtx(() => [withDirectives((openBlock(), createElementBlock("div", { class: normalizeClass(["dtc-theme__canvas d-p-200", { "d-hmx-250": !__props.fullScreen }]) }, [createVNode(_sfc_main$1, {
					info: __props.info,
					options: __props.options,
					theme: __props.settings.root.theme,
					verbose: __props.settings.code.verbose,
					"indent-spaces": __props.settings.code.indent,
					"disabled-members": __props.disabledMembers,
					"dev-mode": __props.devMode,
					"has-changes": __props.hasChanges,
					"onUpdate:options": _cache[0] || (_cache[0] = (e) => emit(unref("update:options"), e))
				}, null, 8, [
					"info",
					"options",
					"theme",
					"verbose",
					"indent-spaces",
					"disabled-members",
					"dev-mode",
					"has-changes"
				])], 2)), [[
					_directive_dt_scrollbar,
					void 0,
					"never"
				]])]),
				overlay: withCtx(() => [createVNode(_component_dt_stack, {
					direction: "row",
					align: "end",
					justify: "end",
					class: "d-h100p"
				}, {
					default: withCtx(() => [createElementVNode("div", _hoisted_1, [renderSlot(_ctx.$slots, "overlay")])]),
					_: 3
				})]),
				_: 3
			}, 8, ["class"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_panel.vue.js.map